import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { flexRender } from '@tanstack/react-table';
import { useEffect } from 'react';
import { styled } from 'styletron-react';
import { zIndexes } from '../../const/zIndexes';
import { Box } from '../layout/Box';
import { DynamicPinningTableCell } from './DynamicPinningTableCell';
import { DynamicPinningTableHeaderCell } from './DynamicPinningTableHeaderCell';
import { DynamicPinningTableLayout } from './DynamicPinningTableLayout';
import { DynamicPinningTableRow } from './DynamicPinningTableRow';
import { getColumnPinningInfo } from './helpers/getColumnPinningInfo';
const StyledDynamicPinningTableRow = styled('tr', {
    position: 'sticky',
    top: 0,
    zIndex: zIndexes.tableRowHeader,
});
export const DynamicPinningTable = ({ table, CellClickableWrapper, disableHeader = false, pinnedColumnCount, }) => {
    const leafHeaders = table.getLeafHeaders();
    const columnIds = leafHeaders.map((header) => header.column.id);
    const columnIdsKey = columnIds.join('|');
    useEffect(() => {
        const pinnedColumnIds = pinnedColumnCount
            ? columnIds.slice(0, pinnedColumnCount)
            : [];
        table.setColumnPinning({ start: pinnedColumnIds, end: [] });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [columnIdsKey, pinnedColumnCount]);
    const isPinningEnabled = pinnedColumnCount > 0;
    const pinnedColumnCountInState = table.store.state.columnPinning.start.length;
    const headerCells = leafHeaders.map((header, columnIndex) => {
        const { column } = header;
        const pinningInfo = getColumnPinningInfo(table, column.id, columnIndex, isPinningEnabled, pinnedColumnCountInState);
        const isSortable = column.getCanSort();
        const sortDirection = column.getIsSorted() || undefined;
        const content = flexRender(column.columnDef.header, header.getContext());
        const handleClick = column.getToggleSortingHandler();
        return (_jsx(DynamicPinningTableHeaderCell, { totalColumns: leafHeaders.length, columnIndex: columnIndex, isSortable: isSortable, sortDirection: sortDirection, pinningInfo: pinningInfo, onClick: handleClick, children: content }, header.id));
    });
    const rows = table.getRowModel().rows.map((row) => {
        const rowId = row.id;
        const isClickable = !!CellClickableWrapper;
        return (_jsx(DynamicPinningTableRow, { isClickable: isClickable, children: (isRowHovered) => row.getVisibleCells().map((cell, columnIndex) => {
                const cellId = cell.id;
                const content = flexRender(cell.column.columnDef.cell, cell.getContext());
                const pinningInfo = getColumnPinningInfo(table, cell.column.id, columnIndex, isPinningEnabled, pinnedColumnCountInState);
                return (_jsx(DynamicPinningTableCell, { rowId: rowId, rowData: row.original, columnId: cell.column.id, CellClickableWrapper: CellClickableWrapper, isRowHovered: isRowHovered, pinningInfo: pinningInfo, children: content }, cellId));
            }) }, rowId));
    });
    const shouldShowHeader = !disableHeader;
    return (_jsx(Box, { overflow: 'auto', children: _jsxs(DynamicPinningTableLayout, { children: [shouldShowHeader && (_jsx("thead", { children: _jsx(StyledDynamicPinningTableRow, { children: headerCells }) })), _jsx("tbody", { children: rows })] }) }));
};
